export const uiInfoApi = async () => {
  const requestUrl = '/info.json';
  try {
    const response = await fetch(requestUrl);
    return response.json();
  } catch (error) {
    return error.response;
  }
};
